import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import OperationBody from "./OperationBody";

const ReportBody = ({ operations }) => {
  return (
    <View>
      <Text style={styles.subHeader}>Toimenpiteet</Text>

      {operations.map((operation) => (
        <OperationBody operation={operation} />
      ))}
    </View>
  );
};

export default ReportBody;

const styles = StyleSheet.create({
  subHeader: {
    fontSize: 20,
    paddingBottom: 10,
    borderBottom: "1px solid grey",
    marginBottom: 10,
  },
  h3: {
    fontSize: 12,
  },
  boldText: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
  },
  text: {
    fontSize: 10,
  },
});



// WEBPACK FOOTER //
// ./src/components/printable/ReportBody.jsx